import React from 'react';
import texts from '../content/texts';

const Locations = () => {

  const formatContent = (content) => {
    return content.replace(/\n/g, '<br />');
  };

  return (
    <section id="locations">
      <span className="line"></span> {/* Linea separatrice */}
      <div className="story-section">
        <h2 className="story-title font-detail">Il Giorno Del Sì</h2>
        
        <div className="locations-container">
          <div className="card location-card">
            <div className="location-icon">
              <span role="img">⛪</span>
            </div>
            <h3 className="location-title font uppercase">{texts.church.name}</h3>
            <div className="location-time font">{texts.church.hour}</div>
            <p className="location-address font-detail bold" dangerouslySetInnerHTML={{ __html: formatContent(texts.church.address) }}></p>
            <div className="location-details font-detail">
              {texts.church.content}
            </div>
            <a 
              href="https://maps.google.com/?q=Chiesa+Santa+Maria+di+Custonaci" 
              target="_blank" 
              rel="noopener noreferrer"
              className="map-link uppercase"
            >
              <i className="map-icon">📍</i> Indicazioni stradali
            </a>
          </div>
          
          <div className="card location-card">
            <div className="location-icon">
              <span role="img">🥂</span>
            </div>
            <h3 className="location-title font uppercase">{texts.place.name}</h3>
            <div className="location-time font">{texts.place.hour}</div>
            <p className="location-address font-detail bold" dangerouslySetInnerHTML={{ __html: formatContent(texts.place.address) }}></p>
            <div className="location-details font-detail">
              {texts.place.content}
            </div>
            <a 
              href="https://maps.google.com/?q=Baglio+Santa+Lucia+Alcamo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="map-link uppercase"
            >
              <i className="map-icon">📍</i> Indicazioni stradali
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Locations;